import { findIndex, cloneDeep } from 'lodash';
import Vue from 'vue';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE = 'SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE';
export const SET_FETCHING_CHANNEL = 'SET_FETCHING_CHANNEL';
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';
export const SYNC_CHANNEL = 'SYNC_CHANNEL';
export const SYNC_ALL_CHANNELS = 'SYNC_ALL_CHANNELS';

const data = {
  channels: [],
  widgetChannels: [],
  channelsGroups: [],
  fetching: false,
  channelsTotal: 0,
  pageSizeDefault: undefined,
  widgetSites: [],
};

const actions = {
  fetchChannels({ commit }) {
    return api.getChannels().then(([channels, groups]) => {
      commit(SYNC_ALL_CHANNELS, { channels });
      commit(SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE, groups);
    });
  },
  fetchChannelsPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(SET_FETCHING);
    return api.getChannelsPagination(page, pageSize)
      .then(([channels, total, pageSizeDefault, groups]) => {
        commit(SYNC_ALL_CHANNELS, {
          channels,
          total,
          moreData,
          pageSizeDefault,
        });
        commit(SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE, groups);
      }).catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  fetchWidgetChannels({ commit }) {
    return api.getWidgetChannels().then((widgetChannels) => {
      commit('SYNC_ALL_WIDGET_CHANNELS', { widgetChannels });
    });
  },
  fetchWidgetSites({ commit }) {
    return api.getWidgetSites().then((widgetSites) => {
      commit('SYNC_ALL_WIDGET_SITES', { widgetSites });
    });
  },
  updateChannel({ commit }, { id, fields, model }) {
    commit(SET_FETCHING_CHANNEL, { id, condition: true });
    return api.updateChannel(id, fields, model).then((channel) => {
      commit(SYNC_CHANNEL, channel);
    })
      .catch((error) => {
        commit(SET_FETCHING_CHANNEL, { id, condition: false });
        throw error;
      });
  },
  removeChannel({ commit }, id) {
    commit(SET_FETCHING_CHANNEL, { id, condition: true });
    return api.deleteChannel(id).then((channel) => {
      commit('REMOVE_CHANNEL', channel.id);
    })
      .catch((error) => {
        commit(SET_FETCHING_CHANNEL, { id, condition: false });
        throw error;
      });
  },
  createChannel({ commit }, { fields, model }) {
    return api.createChannel(fields, model).then((channel) => {
      commit('ADD_CHANNEL', channel);
      commit(SYNC_CHANNEL, channel);
    });
  },
  updateRequestTypePriority(_, { id, weight }) {
    return api.updateRequestTypePriority({ id, weight });
  },
};

const mutations = {
  ADD_CHANNEL(state, channel) {
    state.channels.push({
      fields: [],
      ...channel,
      fetching: false,
    });
  },
  SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE(state, groups) {
    state.channelsGroups = groups;
  },
  SET_FETCHING_CHANNEL(state, { id, condition }) {
    const { channels } = state;
    const channel = channels[findIndex(channels, { id })];
    channel.fetching = condition;
  },
  SYNC_CHANNEL(state, response) {
    const { channels } = state;
    const channel = channels[findIndex(channels, { id: response.id })];
    channel.fetching = false;
    channel.fields = response.fields || [];
    channel.name = response.name;
    channel.priority = response.priority;
    channel.identifier = response.identifier;
    channel.group = response.group;
  },
  SYNC_ALL_CHANNELS(state, {
    channels, total, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.channels = state.channels.concat(cloneDeep(channels.map((channel) => ({
        fields: [],
        ...channel,
        fetching: false,
      }))));
    } else {
      state.channels = cloneDeep(channels.map((channel) => ({
        fields: [],
        ...channel,
        fetching: false,
      })));
    }
    state.channelsTotal = total;
    mutations.SET_STOP_FETCHING(state);
  },
  SYNC_ALL_WIDGET_CHANNELS(state, { widgetChannels }) {
    state.widgetChannels = widgetChannels;
    mutations.SET_STOP_FETCHING(state);
  },
  SYNC_ALL_WIDGET_SITES(state, { widgetSites }) {
    state.widgetSites = widgetSites;
    mutations.SET_STOP_FETCHING(state);
  },
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  REMOVE_CHANNEL(state, id) {
    const { channels } = state;
    Vue.delete(channels, findIndex(channels, { id }));
    state.channelsTotal -= 1;
  },
};

const getters = {
  getChannelById(state) {
    const { channels } = state;
    return (id) => (channels[findIndex(channels, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters,
};

export default store;
